<template>
    <div class="table_wrap">
        <el-table class="list-table" header-cell-class-name="list-header"
                  style="width: 100%;" height="695" empty-text="데이터가 없습니다."
                  :data="itemData" @sort-change="sortChange"
                  :default-sort="{prop: sortType, order: sortOrder}"
        >
            <el-table-column
                    class="table_no"
                    type="index"
                    label="No"
                    width="90"
                    class-name="num text-center"
                    :index="tableIdx"
            >
            </el-table-column>

            <el-table-column label="컬렉션" width="" class-name="text-center" prop="c_title">
                <template slot-scope="scope">
                    <div class="row-info hover" @click="moveDetail(scope.row.c_idx)">
                        {{ scope.row.c_title }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="아이디" width="" class-name="text-center" prop="mb_id">
                <template slot-scope="scope">
                    <div class="row-info ">
                        {{ scope.row.mb_is_use === 0 ? "" : scope.row.mb_id }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="닉네임" width="" class-name="text-center" prop="mb_nick">
                <template slot-scope="scope">
                    <div class="row-info ">
                        {{ scope.row.mb_is_use === 0 ? "" : scope.row.mb_nick }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="아이템 수" width=""
                             class-name="text-center" prop="item_cnt"></el-table-column>
            <el-table-column label="소유자 수" width=""
                             class-name="text-center" prop="owner_cnt"></el-table-column>
            <el-table-column label="유틸리티 수" width=""
                             class-name="text-center" prop="utility_cnt"></el-table-column>
            <el-table-column label="판매총액" width="" :sortable="'custom'" :sort-orders="['ascending', 'descending']"
                             class-name="text-center" prop="c_total"></el-table-column>
            <el-table-column label="좋아요수" width=""
                             class-name="text-center" prop="Likes.cnt"></el-table-column>
            <el-table-column label="양도가능여부" width="" class-name="text-center" prop="">
                <template slot-scope="scope">
                    <div class="row-info ">
                        {{ returnOwner(scope.row) }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="등록일" width="" class-name="text-center" prop="created_at"></el-table-column>


            <el-table-column
                    label="옵션" width="" class-name="text-center">
                <template slot-scope="scope">
                    <div class="row-info ">
                        <el-button class="com_btn" @click="moveDetail(scope.row.c_idx)">
                            상세
                        </el-button>
                    </div>
                </template>
            </el-table-column>
        </el-table>

    </div>
</template>

<script>
import dateMixins from "@/mixins/dateMixins";
import {itemStatus, itemCategory, itemEdition, itemType} from "@/service/itemService";
import util from "@/mixins/util";

export default {
    name: "ItemListCollectionLayout",
    mixins: [dateMixins],
    components: {},
    inject: ['setSort'],
    provide() {
        return {}
    },
    props: {
        itemData: {
            type: Array,
            default: () => {
                return []
            }
        },
        paginationData: {
            type: Object,
            default: () => {
                return {
                    total: 0,
                    page: 0,
                    size: 0,
                }
            }
        },

    },
    data() {
        return {
            sortType: '',
            sortOrder: '',

        }
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {

    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        moveDetail(idx) {
            this.$router.push(`/item/collection/${idx}`);
        },
        tableIdx(index) {
            return this.paginationData.total - index - (this.paginationData.page - 1) * this.paginationData.size;
        },
        returnOwner(data) {
            if (data.c_owner === 1) {
                return '가능'
            }
            return '불가능'
        },
        sortChange({column, prop, order}) {
            if (util.isEmpty(order)) {
                return
            } else {
                this.sortType = prop;
                this.sortOrder = order;
            }
            let orderName = this.getTableOrderName(this.sortOrder);
            this.setSort(this.sortType, orderName);
        },
        getTableOrderName(orderName) {
            return orderName === 'descending' ? 'desc' : orderName === 'ascending' ? 'asc' : null;
        },
    },
    watch: {},
}
</script>

<style scoped>

</style>
